"use client";

import { useState } from "react";
import { proxiedInstagramImageUrl } from "@/libs/instagramImageProxy";

interface ListAvatarProps {
  avatarUrl?: string | null;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const SIZE_CLASS = {
  sm: "h-9 w-9",
  md: "h-12 w-12",
  lg: "h-[72px] w-[72px] sm:h-20 sm:w-20",
} as const;

export default function ListAvatar({
  avatarUrl,
  size = "md",
  className = "",
}: ListAvatarProps) {
  const [failed, setFailed] = useState(false);
  const dim = SIZE_CLASS[size];
  const src = proxiedInstagramImageUrl(avatarUrl);

  if (!src || failed) {
    return <div className={`sk ${dim} shrink-0 rounded-full ${className}`} />;
  }

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={src}
      alt=""
      className={`${dim} shrink-0 rounded-full object-cover ${className}`}
      onError={() => setFailed(true)}
    />
  );
}
